import styled from 'styled-components';
import { key } from 'styled-theme';

export default styled.div`
  margin: 30px 0;

  q {
    font-style: italic;
    font-weight: 600;
    font-size: 20px;
    display: block;
    margin-bottom: 5px;
  }

  small {
    font-size: 16px;
    color: ${key('colors.black.light.400')};
  }

  strong {
    display: inline-block;
    padding-right: 10px;
  }
`;
